import React, { useEffect, useState, useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getPDFApply } from '../../eDocumentsSlice';

const NtsResult_07 = () => {
  const dispatch = useDispatch();
  const { ntsResult } = useSelector(state => state.eDocuments);

  useEffect(() => {
    dispatch(getPDFApply({ htmPCd: '7' }));
  }, []);

  return (
    <div className="yearendManualContentsBox">
      <div className={'ntsResultBox'}>
        <p className={'body2Bold subPoint3 ntsResultTitle'}>개인연금저축 입력 상세 내역</p>
        <Table01
          ntsResult={ntsResult?.list?.filter(item => item?.htm002?.indexOf('개인연금') != -1)}
        />
      </div>
      <div className={'ntsResultBox'}>
        <p className={'body2Bold subPoint3 ntsResultTitle'}>연금저축 입력 상세 내역</p>
        <Table02
          ntsResult={ntsResult?.list?.filter(
            item =>
              item?.htm002?.indexOf('개인연금') == -1 && item?.htm002?.indexOf('연금저축') != -1,
          )}
        />
      </div>
      <div className={'ntsResultBox'}>
        <p className={'body2Bold subPoint3 ntsResultTitle'}>퇴직연금 입력 상세 내역</p>
        <Table02
          ntsResult={ntsResult?.list?.filter(item => item?.htm002?.indexOf('퇴직연금') != -1)}
        />
      </div>
      <div className={'ntsResultBox'}>
        <p className={'body2Bold subPoint3 ntsResultTitle'}>소기업 소상공 입력 상세 내역</p>
        <Table04
          ntsResult={ntsResult?.list?.filter(item => item?.htm002?.indexOf('소기업') != -1)}
        />
      </div>
      <div className={'ntsResultBox'}>
        <p className={'body2Bold subPoint3 ntsResultTitle'}>장기집합투자증권저축</p>
        <Table05
          ntsResult={ntsResult?.list?.filter(item => item?.htm002?.indexOf('장기집합') != -1)}
        />
      </div>
      <div className={'ntsResultBox'}>
        <p className={'body2Bold subPoint3 ntsResultTitle'}>벤처기업투자신탁</p>
        <Table06 ntsResult={ntsResult?.list?.filter(item => item?.htm002?.indexOf('벤처') != -1)} />
      </div>
    </div>
  );
};

export default NtsResult_07;

const Table01 = ({ ntsResult }) => {
  const headListGroup1 = [
    { name: '대상자', width: '15%', key: 'htmPerNm' },
    {
      name: '대상자 주민번호',
      width: '20%',
      key: 'htmRegNum',
    },
    { name: '종류', width: '20%', key: 'htm002' },
    { name: '상호', width: '20%', key: 'htm004' },
    { name: '사업자번호', width: '25%', key: 'htm003' },
  ];

  const headListGroup2 = [
    {
      name: '통장 증권번호',
      width: '35%',
      key: 'htm005',
    },
    {
      name: '계약시작일',
      width: '20%',
      key: 'htm007',
    },
    {
      name: '계약종료일',
      width: '20%',
      key: 'htm008',
    },
    { name: '납입금액	', width: '25%', key: 'htm001', align: 'right' },
  ];

  const headList = [headListGroup1, headListGroup2];

  return (
    <div className="tableWrapper">
      <div>
        {headList.map((headers, _index) => (
          <div className="displayFlex tableTr" key={_index}>
            {headers.map((item, index) => (
              <div
                className="tableTitle captionBold"
                key={index}
                style={{
                  width: item.width,
                  flex: 'none',
                  borderTop: _index == headList.length - 1 && 'none',
                }}>
                {item.name}
              </div>
            ))}
          </div>
        ))}
      </div>

      {/* 데이터 행 */}
      {ntsResult?.map((item, index) => (
        <React.Fragment key={index}>
          {headList.map((headers, headerIndex) => (
            <div className="displayFlex tableTr" key={headerIndex}>
              {headers.map((header, _index) => (
                <div
                  className="tableBody captionMedium"
                  key={_index}
                  style={{
                    width: header.width,
                    flex: 'none',
                    justifyContent: header.align,
                  }}>
                  {item[header.key]}
                </div>
              ))}
            </div>
          ))}
        </React.Fragment>
      ))}
    </div>
  );
};

const Table02 = ({ ntsResult }) => {
  const headListGroup1 = [
    { name: '대상자', width: '25%', key: 'htmPerNm' },
    {
      name: '대상자 주민번호',
      width: '30%',
      key: 'htmRegNum',
    },
    { name: '종류', width: '20%', key: 'htm002' },
    { name: '상호', width: '25%', key: 'htm004' },
  ];

  const headListGroup2 = [
    { name: '사업자번호', width: '25%', key: 'htm003' },
    {
      name: '통장 증권번호',
      width: '30%',
      key: 'htm005',
    },
    {
      name: '당해년도 납입금액',
      width: '20%',
      key: 'htm009',
    },
    {
      name: '순납입금액',
      width: '25%',
      key: 'htm012',
      align: 'right',
    },
  ];

  const headList = [headListGroup1, headListGroup2];

  return (
    <div className="tableWrapper">
      <div>
        {headList.map((headers, _index) => (
          <div className="displayFlex tableTr" key={_index}>
            {headers.map((item, index) => (
              <div
                className="tableTitle captionBold"
                key={index}
                style={{
                  width: item.width,
                  flex: 'none',
                  borderTop: _index == headList.length - 1 && 'none',
                }}>
                {item.name}
              </div>
            ))}
          </div>
        ))}
      </div>

      {/* 데이터 행 */}
      {ntsResult?.map((item, index) => (
        <React.Fragment key={index}>
          {headList.map((headers, headerIndex) => (
            <div className="displayFlex tableTr" key={headerIndex}>
              {headers.map((header, _index) => (
                <div
                  className="tableBody captionMedium"
                  key={_index}
                  style={{
                    width: header.width,
                    flex: 'none',
                    justifyContent: header.align,
                  }}>
                  {item[header.key]}
                </div>
              ))}
            </div>
          ))}
        </React.Fragment>
      ))}
    </div>
  );
};

const Table04 = ({ ntsResult }) => {
  const headListGroup1 = [
    { name: '대상자', width: '25%', key: 'htmPerNm' },
    {
      name: '대상자 주민번호',
      width: '30%',
      key: 'htmRegNum',
    },
    {
      name: '공제계약번호 또는 증서번호',
      width: '45%',
      key: 'htm005',
    },
  ];

  const headListGroup2 = [
    { name: '대상기간 시작', width: '25%', key: 'htm007' },
    { name: '대상기간 종료', width: '30%', key: 'htm008' },
    {
      name: '납입방법',
      width: '15%',
      key: 'htm010',
    },
    {
      name: '월',
      width: '10%',
      key: 'htmMm2',
    },
    {
      name: '납입금액계',
      width: '20%',
      d_width: '30%',
      key: 'htm001',
    },
  ];

  const headList = [headListGroup1, headListGroup2];

  return (
    <div className="tableWrapper">
      <div>
        {headList.map((headers, _index) => (
          <div className="displayFlex tableTr" key={_index}>
            {headers.map((item, index) => (
              <div
                className="tableTitle captionBold"
                key={index}
                style={{
                  width: item.width,
                  flex: 'none',
                  borderTop: _index == headList.length - 1 && 'none',
                }}>
                {item.name}
              </div>
            ))}
          </div>
        ))}
      </div>

      {/* 데이터 행 */}
      {ntsResult?.map((item, index) => (
        <React.Fragment key={index}>
          {headList.map((headers, headerIndex) => (
            <div className="displayFlex tableTr" key={headerIndex}>
              {headers.map((header, _index) => (
                <div
                  className="tableBody captionMedium"
                  key={_index}
                  style={{
                    width: header.width,
                    flex: 'none',
                    justifyContent: header.align,
                  }}>
                  {item[header.key]}
                </div>
              ))}
            </div>
          ))}
        </React.Fragment>
      ))}
    </div>
  );
};

const Table05 = ({ ntsResult }) => {
  const headListGroup1 = [
    { name: '대상자', width: '25%', key: 'htmPerNm' },
    {
      name: '대상자 주민번호',
      width: '30%',
      key: 'htmRegNum',
    },
    { name: '펀드명', width: '50%', key: 'htm006' },
  ];

  const headListGroup2 = [
    { name: '가입일자', width: '25%', key: 'htm007' },
    { name: '연간합계액', width: '30%', key: 'htm001' },
    {
      name: '소득공제대상금액',
      width: '50%',
      key: 'htm009',
    },
  ];

  const headList = [headListGroup1, headListGroup2];

  // const [bodyList, setBodyList] = useState([
  //   { total: "240,000" },
  //   {
  //     htm001: "김국세",
  //     htm002: "740408-2641917",
  //     htm003: "AA투자신탁ClassC",
  //     htm004: "2021-01-25",
  //     htm005: "600,000	",
  //     htm006: "240,000",
  //     htm007: "X",
  //     htm008: "",
  //   },
  // ]);

  return (
    <div className="tableWrapper">
      <div>
        {headList.map((headers, _index) => (
          <div className="displayFlex tableTr" key={_index}>
            {headers.map((item, index) => (
              <div
                className="tableTitle captionBold"
                key={index}
                style={{
                  width: item.width,
                  flex: 'none',
                  borderTop: _index == headList.length - 1 && 'none',
                }}>
                {item.name}
              </div>
            ))}
          </div>
        ))}
      </div>

      {/* 데이터 행 */}
      {ntsResult?.map((item, index) => (
        <React.Fragment key={index}>
          {headList.map((headers, headerIndex) => (
            <div className="displayFlex tableTr" key={headerIndex}>
              {headers.map((header, _index) => (
                <div
                  className="tableBody captionMedium"
                  key={_index}
                  style={{
                    width: header.width,
                    flex: 'none',
                    justifyContent: header.align,
                  }}>
                  {item[header.key]}
                </div>
              ))}
            </div>
          ))}
        </React.Fragment>
      ))}
    </div>
  );
};

const Table06 = ({ ntsResult }) => {
  const headListGroup1 = [
    { name: '대상자', width: '20%', key: 'htmPerNm', d_width: '35%' },
    { name: '납입월', width: '15%', key: 'htmMm2' },
    {
      name: '대상자 주민번호',
      width: '40%',
      key: 'htmRegNum',
    },
    { name: '납입연도', width: '25%', key: 'htm007' },
  ];

  const headListGroup2 = [
    { name: '계좌번호', width: '35%', key: 'htm005' },
    { name: '투자신탁명', width: '40%', key: 'htm006' },
    {
      name: '연간합계액',
      width: '25%',
      key: 'htm001',
      align: 'right',
    },
  ];

  const headList = [headListGroup1, headListGroup2];

  return (
    <div className="tableWrapper">
      <div>
        {headList.map((headers, _index) => (
          <div className="displayFlex tableTr" key={_index}>
            {headers.map((item, index) => (
              <div
                className="tableTitle captionBold"
                key={index}
                style={{
                  width: item.width,
                  flex: 'none',
                  borderTop: _index == headList.length - 1 && 'none',
                }}>
                {item.name}
              </div>
            ))}
          </div>
        ))}
      </div>

      {/* 데이터 행 */}
      {ntsResult?.map((item, index) => (
        <React.Fragment key={index}>
          {headList.map((headers, headerIndex) => (
            <div className="displayFlex tableTr" key={headerIndex}>
              {headers.map((header, _index) => (
                <div
                  className="tableBody captionMedium"
                  key={_index}
                  style={{
                    width: header.width,
                    flex: 'none',
                    justifyContent: header.align,
                  }}>
                  {item[header.key]}
                </div>
              ))}
            </div>
          ))}
        </React.Fragment>
      ))}
    </div>
  );
};
